import { Row, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import API from "../services/api-request";

const SelectProductType = ({ value, onChange }) => {
  const [listData, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getProductType = async () => {
    setLoading(true);
    API.Get(`product-type`)
      .then((res) => {
        const newData = res?.data;
        const filteredData = newData.filter(
          (item) =>
            !listData.find((existingItem) => existingItem.id === item.id)
        );
        setData((prevData) => [...prevData, ...filteredData]);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getProductType();
  }, []);

  return (
    <Select
      style={{ width: "100%" }}
      allowClear
      showSearch
      value={value || null}
      optionFilterProp="label"
      placeholder="Select ProductType"
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={listData?.map((e) => ({
        label: e.size,
        value: e.id,
      }))}
    />
  );
};

export default SelectProductType;
